import React from 'react';
import TextWrapPhoto from '../Photos/TextWrapPhoto';
import './Chapters.scss';
import textWrapPhoto1 from '../../assets/textWrapPhoto1.png';

function Chapter6() {
  const photoData = {
    imgSrc: textWrapPhoto1,
    caption: '',
    float: 'right' //pass in "right" or "left"
  };

  return (
    <section className="chapter">
      <h3 className="chapter__title">Artists Collaborating Across the Globe</h3>
      <p className="chapter__paragraph">
        Besides the ability to stand up virtual studios quickly, Company 3 has realized another
        advantage in shifting to the cloud: the ability to foster a more diverse, collaborative, and
        creative workforce.
      </p>

      <div>
        <TextWrapPhoto photoData={photoData} />
        <p className="chapter__paragraph">
          With postproduction teams working virtually, Company 3 isn’t limited to talent only in Los
          Angeles or London; it can hire the best talent for the job, no matter where they happen to
          be. Production specialists—colorists, mixers, visual effects artists, and the like—that
          previously had to work directly with equipment in specific physical spaces containing the
          tools of their respective trades, can now work synchronously and collaboratively from
          almost anywhere, thanks to these virtual studios.
        </p>
        <p className="chapter__paragraph">
          Meanwhile, Company 3 had been working with Blackmagic Design, manufacturer of Resolve
          postproduction tools, to perfect the hardware that would be necessary to facilitate an
          efficient connection between a colorist’s control panel, wherever in the world it might
          be, and cloud-based media with the speed and efficiency of a traditional workflow based on
          local storage of media assets.
        </p>
        <p className="chapter__paragraph">
          A great example of this idea put into practice is Prime’s hit series The Lord of the
          Rings: The Rings of Power. Company 3 colorist Skip Kimball was able to work from his home
          and collaborate with creatives, production managers, and Company 3’s in-house finishing
          editors all over the world to color grade shots and view them in near real-time. All the
          color grading and postproduction image processing happened in one “virtual facility” in
          the cloud. In the end, the implementation of all this technology enabled the artists to do
          their best work, Keske says.
        </p>
      </div>
    </section>
  );
}

export default Chapter6;
